import { ACTIVITY_MOODS } from "~/activities/constants";

export function moodIco(type: string): string {
	let ico = "";

	ACTIVITY_MOODS.forEach(mood => {
		if (mood.type === type) {
			ico = mood.ico;
		}
	});

	return ico;
}
